import axios from '@/bootstrap'

const endpoint = 'authentication'

export default class AuthenticationService {
  login(params) {
    return axios.post(`/${endpoint}/login`, params).then(res => res.data)
  }

  forgotPassword(params) {
    return axios.post(`/${endpoint}/forgot-password`, params).then(res => res.data)
  }

  resetPassword(params) {
    return axios.post(`/${endpoint}/reset-password`, params).then(res => res.data)
  }
}
